import React from "react";

import { Button } from "@material-ui/core";
import { Add as AddIcon } from "@material-ui/icons";
import { useDispatch } from "react-redux";

import ClientModal from "screens/Clients/components/ClientModal";

import { saveClient } from "store/client/actions";

const AddClientModal = (props) => {
  const dispatch = useDispatch();

  const initialValues = {
    name: "",
    code: "",
    status: "active",
    address: "",
    email: "",
    color: "#1976D2",
    contactPersonName: "",
    contactPersonPhone: "",
    notes: "",
    codeManuallyEdited: false,
  };

  const handleSubmit = (values) => {
    const { codeManuallyEdited, ...clientData } = values;
    dispatch(saveClient(clientData));
  };

  return (
    <ClientModal
      onSubmit={handleSubmit}
      initialValues={initialValues}
      title={"Add client"}
      submitActionText={'Save'}
      cancelActionText={'Discard'}
      isEdit={false}
      OpenerComponent={(props) => (
        <Button
          {...props}
          startIcon={<AddIcon />}
          variant={"contained"}
          color={"secondary"}
        >
          Add client
        </Button>
      )}
    />
  );
};

AddClientModal.propTypes = {};

export default AddClientModal;

